module.exports = __webpack_public_path__ + "media/img/help_center/Student_Test_11-a2aea30acee8d9ee9bb869c98ec2ff2b.jpg";